/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_POLICY_HOLDER_DETAIL = gql`
  query GetUser($input: GetUserInput) {
    getUser(input: $input) {
      email
      firstName
      image
      emailVerified
      kycSubmitted
      phoneVerified
      primaryContactNo
      kyc {
        detail {
          gender
          occupation
          firstName
          lastName
          primaryContactNo
          address {
            addressLine1
            addressLine2
            addressLine3
            city
            country
            state
          }
        }
        docs {
          status
          fileType
          _id
          type
          doc
          name
        }
        policies {
          policyId
          productDefination
        }
      }
      lastName
      occupation
      vuid
      userId
      address {
        addressLine1
        city
        country
      }
    }
  }
`;
